import React, { Component } from "react";
import axios from "axios";

import PresentationModal from "./PresentationModal.jsx";

export default class PresentationModalContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    showModal() {
        axios.post("/analytics_messages.json", { name: this.props.area.name, member_id: this.props.area.presentations[0].member_id });
        this.setState({ showModal: true });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    render() {
        return (
            <div>
                <div className="name">{this.props.area.name}</div>
                <div className="view" onClick={this.showModal}>View presentation</div>
                <PresentationModal presentation={this.props.presentation} area={this.props.area} showModal={this.state.showModal} closeModal={this.closeModal} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/PresentationModalContainer.jsx.erb